import TitularDashboard from './TitularDashboard';
import { Navigate } from 'react-router';

const Dashboard = ({ user, setUser }) => {
  if (user.rol === 'ADMIN' || user.rol === 'POST') {
    return (
      <Navigate
        replace
        to="/socios"
      />
    );
  }
  if (user.rol === 'TITULAR') {
    return (
      <TitularDashboard
        user={user}
        setUser={setUser}
      />
    );
  } else {
    return null;
  }
};

export default Dashboard;
